import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=5974be77&scoped=true"
import script from "./ExportData.vue?vue&type=script&lang=ts"
export * from "./ExportData.vue?vue&type=script&lang=ts"
import style0 from "./ExportData.vue?vue&type=style&index=0&id=5974be77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974be77",
  null
  
)

export default component.exports